import script from "./ConsultHintChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultHintChip.vue?vue&type=script&setup=true&lang=js"

import "./ConsultHintChip.vue?vue&type=style&index=0&id=30f83821&scoped=true&lang=css"

import exportComponent from "../../../../../../vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f83821"]])

export default __exports__